import { cva } from 'class-variance-authority';

const autocompleteOptionBaseStyles = [
  'p-3',
  'cursor-pointer',
  'flex',
  'items-center',
];

const autocompleteOptionStylesSAG = cva([
  ...autocompleteOptionBaseStyles,
  'hover:bg-[#62EEC7]',
  'dark:hover:bg-[#005159]',
]);

const autocompleteOptionSelectedStylesSAG = cva([
  ...autocompleteOptionBaseStyles,
  'bg-[#62EEC7]',
  'dark:bg-[#005159]',
]);

const autocompleteionOptionTextStylesSAG = cva(['text-[#000028]', 'dark:text-white', 'w-full']);

const autocompleteOptionStylesSHS = cva([
  ...autocompleteOptionBaseStyles,
  'hover:bg-[#f2f2f2]',
  'dark:hover:bg-[#474747]',
]);

const autocompleteOptionSelectedStylesSHS = cva([
  ...autocompleteOptionBaseStyles,
  'bg-[#e6e6e6]',
  'dark:bg-[#666]',
]);

const autocompleteionOptionTextStylesSHS = cva(['dark:text-[#e6e6e6]', 'w-full']);

export {
  autocompleteOptionStylesSAG,
  autocompleteOptionStylesSHS,
  autocompleteionOptionTextStylesSAG,
  autocompleteionOptionTextStylesSHS,
  autocompleteOptionSelectedStylesSAG,
  autocompleteOptionSelectedStylesSHS,
};
